import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a180196"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("5")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_amplify_sign_out = _resolveComponent("amplify-sign-out")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_IonSplitPane = _resolveComponent("IonSplitPane")!
  const _component_IonApp = _resolveComponent("IonApp")!

  return (_openBlock(), _createBlock(_component_IonApp, null, {
    default: _withCtx(() => [
      _createVNode(_component_IonSplitPane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_menu, {
            "content-id": "main-content",
            type: "overlay"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, { id: "inbox-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedIndex = 0)),
                            "router-direction": "root",
                            "router-link": "/market",
                            lines: "none",
                            detail: "false",
                            class: _normalizeClass(["hydrated", { selected: _ctx.selectedIndex === 0 }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                ios: "personOutline",
                                md: "personSharp"
                              }),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("menu.market")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          (_ctx.store.state.gameStateId)
                            ? (_openBlock(), _createBlock(_component_ion_item, {
                                key: 0,
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedIndex = 1)),
                                "router-direction": "root",
                                "router-link": "/story",
                                lines: "none",
                                detail: "false",
                                class: _normalizeClass(["hydrated", { selected: _ctx.selectedIndex === 1 }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    ios: "bookOutline",
                                    md: "bookSharp"
                                  }),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t("menu.story")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.store.state.gameStateId)
                            ? (_openBlock(), _createBlock(_component_ion_item, {
                                key: 1,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedIndex = 2)),
                                "router-direction": "root",
                                "router-link": "/part/mariannemichaels",
                                lines: "none",
                                detail: "false",
                                class: _normalizeClass(["hydrated", { selected: _ctx.selectedIndex === 2 }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    ios: "personOutline",
                                    md: "personSharp"
                                  }),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t("menu.role")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.store.state.gameStateId)
                            ? (_openBlock(), _createBlock(_component_ion_item, {
                                key: 2,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedIndex = 3)),
                                "router-direction": "root",
                                "router-link": "/messages",
                                lines: "none",
                                detail: "false",
                                class: _normalizeClass(["hydrated", { selected: _ctx.selectedIndex === 3 }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    ios: "mailOutline",
                                    md: "mailSharp"
                                  }),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t("menu.messages")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_badge, { color: "danger" }, {
                                    default: _withCtx(() => [
                                      _hoisted_1
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_amplify_sign_out)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}